import React, { useState, useEffect } from 'react';
import HeaderSeccion from './Main/Header';
import BodySeccion from './Main/Body';
import FooterSeccion from './Main/Footer';
import Detalles from './Detalles';
import { esCelular, topFooterOnExpanded, widthCelular } from './Config';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useUrlParams } from './hooks/useUrlParams';

interface MainProps {
  onToggleDetalles: (id: any) => void;
}

const Main: React.FC<MainProps> = ({ onToggleDetalles }) => {
  const [filtrar, setFilters] = useState<number>(0);
  const [codigoDivipola, setCodigoDivipola] = useState('');
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);
  const [isFooterExpanded, setIsFooterExpanded] = useState(false);

  // Capturar parámetros de URL
  const { primeraInfancia, ids, hasUrlParams,tiposClasificadores } = useUrlParams();

  useEffect(() => {
    if (hasUrlParams) {
      console.log('Parámetros URL detectados:');
      console.log('Primera Infancia:', primeraInfancia);
      console.log('IDs:', ids);
      
      // Aquí puedes cambiar la lógica de la aplicación
      if (primeraInfancia) {
        // Lógica específica para primera infancia
        console.log('Modo Primera Infancia activado');
      }
      if(tiposClasificadores) {
        console.log('Tipos Clasificadores:', tiposClasificadores);
      }
      
      if (ids.length > 0) {
        // Lógica específica para los IDs
        console.log('IDs específicos a filtrar:', ids);
      }
    }
  }, [primeraInfancia, ids, hasUrlParams]);

  // Determinar filtros visibles basado en parámetros URL
  const getVisibleFilters = () => {
    /*
    if (primeraInfancia) {
      // Filtros específicos para primera infancia
      return ["Anio", "TipoClasificador", "DivipolaDpto", "DivipolaMpio"];
    }
    */
    // Filtros por defecto
    return ["Anio", "TipoClasificador", "DivipolaDpto", "DivipolaMpio", "Sector", "Entidad", "DivipolaPdetDepartamento", "DivipolaPdetRegion", "DivipolaPdetMunicipio"];
  };

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {esCelular ? (
        <>
          <div>
            <button
              onClick={() => setIsHeaderExpanded(!isHeaderExpanded)}
              style={{
                width: '100%',
                padding: '10px',
                background: '#f0f0f0',
                border: 'none',
                borderBottom: '1px solid #ddd',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <span>Filtros</span>
              {isHeaderExpanded ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            <div style={{
              maxHeight: isHeaderExpanded ? '500px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out'
            }}>
              <HeaderSeccion
                onFilterChange={setFilters}
                codigoDivipola={codigoDivipola}
                visibleFilters={getVisibleFilters()}
              />
            </div>
          </div>
          <BodySeccion
            setCodigoDivipola={setCodigoDivipola}
            filtrar={filtrar}
            codigoDivipola={codigoDivipola}
          />
          <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column-reverse' }}>
            <button
              onClick={() => setIsFooterExpanded(!isFooterExpanded)}
              style={{
                width: '100%',
                padding: '10px',
                background: '#f0f0f0',
                border: 'none',
                borderTop: '1px solid #ddd',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <span>Detalles</span>
              {isFooterExpanded ? <FaChevronDown /> : <FaChevronUp />}
            </button>
            <div style={{
              backgroundColor: '#f0f0f0',
              maxHeight: isFooterExpanded ? '400px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              //flexGrow: isFooterExpanded ? 1 : 0,
              height: isFooterExpanded ? '400px' : '0',
              position: isFooterExpanded ? 'absolute' : 'relative',
              top: isFooterExpanded ? topFooterOnExpanded : '0',
              width: widthCelular,
            }}>
              <FooterSeccion
                codigoDivipola={codigoDivipola}
                filtrar={filtrar}
                onToggleDetalles={onToggleDetalles}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <HeaderSeccion
            onFilterChange={setFilters}
            codigoDivipola={codigoDivipola}
            visibleFilters={getVisibleFilters()}
          />
          <BodySeccion
            setCodigoDivipola={setCodigoDivipola}
            filtrar={filtrar}
            codigoDivipola={codigoDivipola}
          />
          <FooterSeccion
            codigoDivipola={codigoDivipola}
            filtrar={filtrar}
            onToggleDetalles={onToggleDetalles}
          />
        </>
      )}
    </div>
  );
};

export default Main;